import {
    ActivityFilterKey,
    useAccountFilter,
    useActivityListFilter,
    useAddOnFilter,
    useAssetListFilter,
    useFileFilter,
    useGroupListFilter,
    useProductFilter,
    useRoutineFilter,
    useWorkspaceFilter,
} from '@gripp/shared-logic';
import { BaseFilterButton } from './baseFilterButton';

export enum FilterType {
  ACCOUNT,
  ACCOUNTCOLUMNS,
  ACCOUNTGROUPS,
  ACCOUNTTYPES,
  ACTIVITYTYPES,
  ACTIVITYLABELS,
  ACTIVITYGROUPS,
  ACTIVITYDATE,
  ASSETGROUPS,
  ASSETCOLUMNS,
  GROUPCOLUMNS,
  ROUTINECOLUMNS,
  PRODUCTCOLUMNS,
  FILECOLUMNS,
  FILECATEGORIES,
  ADDONCOLUMNS,
  WORKSPACECOLUMNS,
}

type FilterButtonProps = {
  type: FilterType;
  filterKey?: string;
  onGoFilter: () => void;
};

export const FilterButton = (props: FilterButtonProps) => {
  let FilterComponent;

  switch (props.type) {
    case FilterType.ACCOUNTGROUPS:
      FilterComponent = AccountGroupsFilterButton;
      break;
    case FilterType.ACCOUNTCOLUMNS:
      FilterComponent = AccountColumnsFilterButton;
      break;
    case FilterType.ACCOUNTTYPES:
      FilterComponent = AccountTypesFilterButton;
      break;
    case FilterType.ACTIVITYTYPES:
      FilterComponent = ActivityTypesFilterButton;
      break;
    case FilterType.ACTIVITYLABELS:
      FilterComponent = ActivityLabelsFilterButton;
      break;
    case FilterType.ACTIVITYDATE:
      FilterComponent = ActivitDateFilterButton;
      break;
    case FilterType.ACTIVITYGROUPS:
      FilterComponent = ActivityGroupsFilterButton;
      break;
    case FilterType.ASSETGROUPS:
      FilterComponent = AssetGroupsFilterButton;
      break;
    case FilterType.ASSETCOLUMNS:
      FilterComponent = ColumnsFilterButton;
      break;
    case FilterType.GROUPCOLUMNS:
      FilterComponent = GroupColumnsFilterButton;
      break;
    case FilterType.ROUTINECOLUMNS:
      FilterComponent = RoutineColumnsFilterButton;
      break;
    case FilterType.PRODUCTCOLUMNS:
      FilterComponent = ProductColumnsFilterButton;
      break;
    case FilterType.FILECOLUMNS:
      FilterComponent = FileColumnsFilterButton;
      break;
    case FilterType.FILECATEGORIES:
      FilterComponent = FileCategoriesFilterButton;
      break;
    case FilterType.ADDONCOLUMNS:
      FilterComponent = AddOnColumnsFilterButton;
      break;
    case FilterType.WORKSPACECOLUMNS:
      FilterComponent = WorkspaceColumnsFilterButton;
      break;
    default:
      FilterComponent = () => null;
      break;
  }

  return <FilterComponent {...props} />;
};

const ActivityTypesFilterButton = (props: FilterButtonProps) => {
  const { data } = useActivityListFilter(props.filterKey as ActivityFilterKey);
  const label = 'activity.filter.types';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        isTypesFilter={true}
        onGoFilter={props.onGoFilter}
      />
    )
  );
};

const ActivityLabelsFilterButton = (props: FilterButtonProps) => {
  const { data } = useActivityListFilter(props.filterKey as ActivityFilterKey);
  const label = 'activity.filter.labels';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        isLabelsFilter={true}
        onGoFilter={props.onGoFilter}
      />
    )
  );
};

const ActivityGroupsFilterButton = (props: FilterButtonProps) => {
  const { data } = useActivityListFilter(props.filterKey as ActivityFilterKey);
  const label = 'activity.filter.groups';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
      />
    )
  );
};

const AssetGroupsFilterButton = (props: FilterButtonProps) => {
  const { data } = useAssetListFilter();
  const label = 'assets.filter.groupsButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
      />
    )
  );
};

const ColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useAssetListFilter();
  const label = 'assets.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const RoutineColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useRoutineFilter();
  const label = 'routine.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const ProductColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useProductFilter();
  const label = 'product.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const FileColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useFileFilter();

  const icon = 'table-chart';
  const label = 'file.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const GroupColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useGroupListFilter();

  const icon = 'table-chart';
  const label = 'groups.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const AccountGroupsFilterButton = (props: FilterButtonProps) => {
  const { data } = useAccountFilter();
  const label = 'account.filter.groupsButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
      />
    )
  );
};

const AccountColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useAccountFilter();
  const label = 'account.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const AccountTypesFilterButton = (props: FilterButtonProps) => {
  const { data } = useAccountFilter();
  const label = 'account.filter.accountTypesButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isAccountTypesFilter={true}
      />
    )
  );
};

const ActivitDateFilterButton = (props: FilterButtonProps) => {
  const { data } = useActivityListFilter(props.filterKey as ActivityFilterKey);
  const label = 'activity.filter.date';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        isDateFilter
        onGoFilter={props.onGoFilter}
      />
    )
  );
};

const AddOnColumnsFilterButton = (props: FilterButtonProps) => {
  const { data } = useAddOnFilter();
  const label = 'addOn.filter.columnButton';

  return (
    data && (
      <BaseFilterButton
        label={label}
        filter={data}
        onGoFilter={props.onGoFilter}
        isColumnsFilter={true}
      />
    )
  );
};

const WorkspaceColumnsFilterButton = (props: FilterButtonProps) => {
  const { data: workspaceFilter } = useWorkspaceFilter();
  const label = 'workspace.filter.columnButton';

  return (
    workspaceFilter && (
      <BaseFilterButton
        {...props}
        filter={workspaceFilter}
        isColumnsFilter={true}
        label={label}
      />
    )
  );
};

const FileCategoriesFilterButton = (props: FilterButtonProps) => {
  const { data } = useFileFilter();
  const icon = 'label-outline';
  const label = 'file.filter.categories';

  return (
    data && (
      <BaseFilterButton
        icon={icon}
        label={label}
        filter={data}
        isCategoriesFilter={true}
        onGoFilter={props.onGoFilter}
      />
    )
  );
};
